// @ts-ignore
import jwt from "jsonwebtoken";

import { getTokenCookie } from "common/context/auth/token-cookie";

const ROLES_KEY =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const ADMINISTRATOR_ROLE = "Administrator";
export const ADMINISTRATOR = {
  value: ADMINISTRATOR_ROLE,
  label: "Administrator",
};

export const BUDGET_COORDINATOR_ROLE = "Budget_Coordinator";
export const BUDGET_COORDINATOR = {
  value: BUDGET_COORDINATOR_ROLE,
  label: "Budget Coordinator",
};

export const BUDGET_OWNER_ROLE = "Budget_Owner";
export const BUDGET_OWNER = {
  value: BUDGET_OWNER_ROLE,
  label: "Budget Owner",
};

export const HR_COORDINATOR_ROLE = "HR_Coordinator";
export const HR_COORDINATOR = {
  value: HR_COORDINATOR_ROLE,
  label: "HR Coordinator",
};

export function getRole() {
  const payload = jwt.decode(getTokenCookie());
  const payloadElement:
    | typeof ADMINISTRATOR
    | typeof BUDGET_COORDINATOR_ROLE
    | typeof BUDGET_OWNER_ROLE
    | typeof HR_COORDINATOR_ROLE
    | undefined = payload?.[ROLES_KEY];

  return payloadElement ?? "";
}

export function isBudgetCoordinator() {
  return getRole() === BUDGET_COORDINATOR_ROLE;
}

export function isBudgetOwner() {
  return getRole() === BUDGET_OWNER_ROLE;
}

export function isHRCoordinator() {
  return getRole() === HR_COORDINATOR_ROLE;
}
